import moment from 'moment';
import {
  allIsFalse,
  DEFAULT_VALID,
  DEFAULT_VALIDATION_MODEL,
  firstDateIsBefore,
  requiredIsValid,
  validaData,
  ValidationModel,
} from 'helpers/utils/ValidationUtils';

export type FilterValidatorType = {
  coopIsRequired: () => ValidationModel;
  eventTypeIsRequired: () => ValidationModel;
  modalidadeIsRequired: () => ValidationModel;
  statusIsRequired: () => ValidationModel;
  initialDateIsValid: () => ValidationModel;
  endDateIsValid: () => ValidationModel;
  allIsValid: () => boolean;
};

export const FiltroValidator = (filter: {
  idEvent: number | Number[];
  coop: String[];
  eventType: String[];
  modalidade: String[];
  status: String[];
  startDate: string;
  endDate: string;
}) => {
  const validator: Partial<FilterValidatorType> = {};

  validator.coopIsRequired = () => {
    const required = requiredIsValid(filter.coop, 'Cooperativa é obrigatório');

    if (required.error) {
      return required;
    }

    return DEFAULT_VALID;
  };

  validator.eventTypeIsRequired = () => {
    const required = requiredIsValid(
      filter.eventType,
      'Tipo evento é obrigatório'
    );

    if (filter.idEvent) {
      return DEFAULT_VALID;
    } else {
      if (required.error) {
        return required;
      }
    }

    return DEFAULT_VALID;
  };

  validator.modalidadeIsRequired = () => {
    const required = requiredIsValid(
      filter.modalidade,
      'Modalidade do evento é obrigatória'
    );

    if (filter.idEvent) {
      return DEFAULT_VALID;
    } else {
      if (required.error) {
        return required;
      }
    }

    return DEFAULT_VALID;
  };

  validator.statusIsRequired = () => {
    const required = requiredIsValid(
      filter.status,
      'Status do evento é obrigatório'
    );

    if (filter.idEvent) {
      return DEFAULT_VALID;
    } else {
      if (required.error) {
        return required;
      }
    }

    return DEFAULT_VALID;
  };

  validator.initialDateIsValid = () => {
    const startDate = moment(filter.startDate).format('DD/MM/YYYY');
    const required = requiredIsValid(startDate, 'Data início é obrigatória');

    if (filter.idEvent) {
      return DEFAULT_VALID;
    } else {
      if (required.error) {
        return required;
      }

      const isValid = validaData(startDate);

      if (!isValid) {
        return DEFAULT_VALIDATION_MODEL(true, 'Data início inválida');
      }

      const endDate = moment(filter.endDate).format('DD/MM/YYYY');
      if (firstDateIsBefore(endDate, startDate)) {
        return DEFAULT_VALIDATION_MODEL(
          true,
          'Data início deve ser anterior ou igual à data fim'
        );
      }
    }

    return DEFAULT_VALID;
  };

  validator.endDateIsValid = () => {
    const endDate = moment(filter.endDate).format('DD/MM/YYYY');
    const required = requiredIsValid(endDate, 'Data fim é obrigatória');

    if (filter.idEvent) {
      return DEFAULT_VALID;
    } else {
      if (required.error) {
        return required;
      }

      const isValid = validaData(endDate);

      if (!isValid) {
        return DEFAULT_VALIDATION_MODEL(true, 'Data fim inválida');
      }

      const startDate = moment(filter.startDate).format('DD/MM/YYYY');
      if (firstDateIsBefore(endDate, startDate)) {
        return DEFAULT_VALIDATION_MODEL(
          true,
          'Data fim deve ser posterior à data início'
        );
      }
    }

    return DEFAULT_VALID;
  };

  validator.allIsValid = () => {
    return allIsFalse(
      filter.idEvent
        ? [validator?.coopIsRequired!().error]
        : [
            validator?.initialDateIsValid!().error,
            validator?.endDateIsValid!().error,
            validator?.coopIsRequired!().error,
            validator?.eventTypeIsRequired!().error,
            validator?.modalidadeIsRequired!().error,
            validator?.statusIsRequired!().error,
          ]
    );
  };

  return validator as FilterValidatorType;
};
